import React, { useEffect, useState } from "react";
import { object, array, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { LazyCollection } from "@quintype/components";
import DfpAd from "../dfp-ad";

import { getCollectionTemplate } from "../get-collection-template";

import { setMobileFilter } from "../helper/actions";
import { useAutoRefresh } from "../utils/react-utils";
import { googleTagEvents } from "../utils/utils";

import "./home.m.css";

const HomePageBase = ({ pageType, data, domainMenuItemsObj, currentPath, domainSlug, publisherAttributes }) => {
  const customAds = get(publisherAttributes, ["customAds"], {});
  // NTG
  const [scroll, setScroll] = useState(0);
  const scrollEventTrigger = (value) => {
    googleTagEvents("article-milestone", "Home Page", value);
  };
  useEffect(() => {
    const scrollCalculate = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 25 && scrollPercentRounded < 50) {
        if (scroll < 25) {
          setScroll(25);
          scrollEventTrigger(25);
        }
      } else if (scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        if (scroll < 50) {
          setScroll(50);
          scrollEventTrigger(50);
        }
      } else if (scrollPercentRounded >= 75 && scrollPercentRounded < 99) {
        if (scroll < 75) {
          setScroll(75);
          scrollEventTrigger(75);
        }
      } else if (scrollPercentRounded >= 99) {
        if (scroll < 99) {
          setScroll(99);
          scrollEventTrigger(100);
        }
      }
    };
    if (window) {
      window.addEventListener("scroll", scrollCalculate);
      return () => {
        window.removeEventListener("scroll", scrollCalculate);
      };
    }
  }, [scroll]);

  useAutoRefresh(pageType);

  return (
    <>
      {pageType === "home-page" && customAds.takeover && (
        <div className="adbox-container">
          <DfpAd adtype="takeover1x1" />
        </div>
      )}
      <div styleName="home-wrapper">
        <div styleName="collection-container">
          {data.collection && (
            <LazyCollection
              liveBlogStory={data.liveBlogStory}
              collection={data.collection}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={1}
              mostCommentedStories={data.mostCommentedStories}
            />
          )}
        </div>
      </div>
    </>
  );
};

HomePageBase.propTypes = {
  data: object,
  domainMenuItemsObj: array,
  pageType: string,
  currentPath: string,
  domainSlug: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  menu: get(state, ["qt", "data", "navigationMenu"], []),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
  domainSlug: get(state, ["qt", "domainSlug"]),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
});

export const HomePage = connect(mapStateToProps, mapDispatchToProps)(HomePageBase);
